module.exports = __webpack_public_path__ + "media/boschautoparts/mobile-logo-eac773eb.png";